import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/roster',
    name: 'Roster',
    component: () => import('@/views/TeamRoster.vue'),
    meta: {
      layout: 'LayoutAuthenticated',
      requiresAuth: true,
      title: 'pageRoster.metaTitle',
    },
  },
];
export default routes;
